import { Subscription, finalize } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';
import { NgIf } from '@angular/common'
import { AppComponent } from '../../../app.component';
import { FormsModule,    ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { AdminAuthGuard } from '../../../services/admin-auth-guard';

@Component({
    standalone:true,
    imports:[ReactiveFormsModule,SpinnerComponent,FormsModule,NgIf],
    providers:[AdminAuthGuard],
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.css']
})

export class LoginFormComponent implements OnInit, OnDestroy {

    private subscription!: Subscription;

    brandNew!: boolean;
    errors!: string;
    isRequesting!: boolean;
    submitted: boolean = false;
    credentials: any = { email: '', password: '' };
    returnUrl!: string;

    constructor(private userService: UserService, private router: Router,
        private activatedRoute: ActivatedRoute, private mainComponet: AppComponent) { }

    ngOnInit() {

        // subscribe to router event
        this.subscription = this.activatedRoute.queryParams.subscribe(
            (param: any) => {
                this.brandNew = param['brandNew'];
                this.credentials.email = param['email'];
                this.returnUrl = param['returnUrl'];
            });
    }

    ngOnDestroy() {
        // prevent memory leak by unsubscribing
        this.subscription.unsubscribe();
    }

    login({ value, valid }: { value: any, valid: any }) {
        this.submitted = true;
        this.isRequesting = true;
        this.errors = '';
        console.log('step 1')
        if (valid) {
            console.log('step 2');
            
            this.userService.login(value.email, value.password)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe(
                    result => {
                        console.log(result,"result")
                        if (result) {                                                       
                            this.router.navigate(['/']);                      

                        }
                    },
                    error => this.errors = error);
        }
    }
}
